import Agent from '../Core/agent';

const BasketApi = {
    add: () => {
    },
    delete: (productId, basketId, coupon, paymentVariant) => {
        return Agent.post(
            '/includes/modules/cart/cart_functions.php',
            new window.URLSearchParams({
                action: "deletefromcart",
                product_id: productId,
                basket_id: basketId,
                coupon,
                paymentVariant
            }),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
    },
    update: (productId, count, coupon, paymentVariant) => {

        const queryData = {
            action: 'rebuildcard',
            basket_id: productId,
            coupon: coupon,
            count,
            paymentVariant
        };

        return Agent.post(
            '/includes/modules/cart/cart_functions.php',
            'data=' + JSON.stringify(queryData),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
    },
    coupon: async coupon => {
        const queryData = {
            action: 'coupon',
            coupon: coupon,
        };
        return Agent.post(
            '/includes/modules/cart/cart_functions.php',
            'data=' + JSON.stringify(queryData),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
    },

    cartData: async (coupon, paymentVariant) => {
        const queryData = {
            action: 'cartData',
            coupon,
            paymentVariant
        };
        return Agent.post(
            '/includes/modules/cart/cart_functions.php',
            'data=' + JSON.stringify(queryData),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
    },

    reject: async (basketId, coupon) => {
        return Agent.post(
            '/includes/modules/cart/cart_functions.php',
            new window.URLSearchParams({
                action: "reject",
                basket_id: basketId,
                coupon: coupon
            }),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
    }
};
export default BasketApi;